import { TextField } from "@mui/material";

export function IaxTimeField({tfonchange, tfvalue, tflabel, tfrequired}) {
  return (
    <TextField
      type="time"
      variant="filled"
      InputLabelProps={{ shrink: true }}
      color="secondary"
      label={tflabel}
      onChange={tfonchange}
      value={tfvalue}
      fullWidth
      required={tfrequired}
      sx={{ mb: 4 }}
    />
  );
}
